import { createSlice } from "@reduxjs/toolkit";
import { getReportProject, fetchCostReport, fetchCostSummary, fetchBlockReport } from "./thunk";

const initialState = {
  reportData: [],
  costReport: null,
  costReportLoading: false,
  blockReport: null,
  blockReportLoading: false,
  costSummary: [],
  costSummaryLoading: false,
  error: {},
  isReportSuccess: false,
};

const reportSlice = createSlice({
  name: "ReportSlice",
  initialState,
  reducers: {
    clearCostReport(state)  { state.costReport  = null; },
    clearCostSummary(state) { state.costSummary = []; },
    clearBlockReport(state) { state.blockReport = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReportProject.fulfilled, (state, action) => {
        state.reportData = action.payload;
        state.isReportSuccess = true;
        state.error = null;
      })
      .addCase(getReportProject.rejected, (state, action) => {
        state.error = action.payload || "Failed to fetch project report";
        state.isReportSuccess = false;
      })
      .addCase(fetchCostReport.pending, (state) => {
        state.costReportLoading = true;
        state.error = null;
      })
      .addCase(fetchCostReport.fulfilled, (state, action) => {
        state.costReportLoading = false;
        state.costReport = action.payload;
      })
      .addCase(fetchCostReport.rejected, (state, action) => {
        state.costReportLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchBlockReport.pending, (state) => {
        state.blockReportLoading = true;
        state.error = null;
      })
      .addCase(fetchBlockReport.fulfilled, (state, action) => {
        state.blockReportLoading = false;
        state.blockReport = action.payload;
      })
      .addCase(fetchBlockReport.rejected, (state, action) => {
        state.blockReportLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchCostSummary.pending, (state) => {
        state.costSummaryLoading = true;
      })
      .addCase(fetchCostSummary.fulfilled, (state, action) => {
        state.costSummaryLoading = false;
        state.costSummary = action.payload;
      })
      .addCase(fetchCostSummary.rejected, (state, action) => {
        state.costSummaryLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCostReport, clearCostSummary, clearBlockReport } = reportSlice.actions;
export default reportSlice.reducer;
